export enum CallResultEnum {

   busy,
   no_answer,
   no_time,
   success,
   no_connection, // TM-1000001509: added new call result "Kein Anschluss" (appended to preserve ordinals)
}